import React from 'react'
import AnimateImageFive from './AnimateImageFive'
import AnimateTitleFive from './AnimatedTitleFive'

const ArchiveStudio = () => {
    return (
        <section className='section-archive-studio section-padding' id='archive-studio'>
            <div className='container'>
                <div className='row'>
                    <div className='col-md-5'>
                    <div className='section-img-heading'>
                    <div className='animated-image-wrapper'>
                        <AnimateImageFive/>
                    </div>
                    <div className='section-title'>
                        <AnimateTitleFive/>
                     </div>
                     </div>
                </div>
                <div className='col-md-7'>
                   <div className='section-content-wrapper'>
                     <div className='section-paragraph'>
                        <p>Our <strong>Archive Studio</strong> is a repository of creativity and memory — where past collections, embroidery swatches, and design samples are preserved. It’s a place for reflection and inspiration, allowing our team to revisit, reinterpret, and reinvent from a foundation of heritage and innovation. Each archived piece serves as a reminder of the evolution of our craft and the enduring beauty of handwork.</p>
                     </div>
                   </div>
                </div>
                </div>
            </div>
        </section>
    )
}

export default ArchiveStudio